module.exports = __webpack_public_path__ + "static/media/Reed DesRosiers.f968d5a4.png";